export const AdminProfileModalIcon = ({ size = 12, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M5.78 1.633a.25.25 0 0 1 .439 0l1.476 2.802a.5.5 0 0 0 .758.147L10.59 2.75a.25.25 0 0 1 .4.26L9.572 8.131a.5.5 0 0 1-.478.367h-6.19a.5.5 0 0 1-.479-.367L1.01 3.01a.25.25 0 0 1 .399-.26l2.138 1.832a.5.5 0 0 0 .758-.147zM2.5 10.5h7"
      stroke="#0e966f"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
